import _ from "lodash";
import Vue from "vue";
import Vuex from "vuex";
import baseStore from "../../../stores/baseStore";
import alertsStore from "../../../stores/modules/alerts.store";
import authStore from "../../../stores/modules/auth.store";
import errorsStore from "../../../stores/modules/errors.store";

Vue.use(Vuex);

const clientPortalStore = new Vuex.Store(_.merge(
	baseStore,
	{
		state: {
			idCheckSession: null,
			idCheckSessionTerminated: false,
		},
		modules: {
			alertsStore,
			authStore,
			errorsStore,
		},
		getters: {
			essentialTasks: (state) => (instruction = null) => {
				let tasks = Object.values(state.authStore.authed?.essentialTasks);

				if (!instruction) {
					return tasks;
				}

				return _.filter(tasks, (task) => {
					return (task.data.instructions || []).indexOf(instruction.id) > -1;
				});
			},
			incompleteTasks: (state, getters) => (instruction = null) => {
				return _.filter(getters.essentialTasks(instruction), task => {
					return !task.complete;
				});
			},
			completeTasks: (state, getters) => (instruction = null) => {
				return _.filter(getters.essentialTasks(instruction), task => {
					return task.complete;
				});
			},
			steppedTasks: (state, getters) => (instruction = null) => {
				return _.filter(getters.incompleteTasks(instruction), task => {
					return !task.canWait;
				});
			},
			remainingTasks: (state, getters) => (instruction = null) => {
				let tasks = getters.steppedTasks(instruction);

				let otherTasks = _.filter(getters.incompleteTasks(instruction), task => {
					return task.canWait;
				});

				_.each(otherTasks, task => {
					tasks.push(task);
				});

				return tasks;
			},
			nextTask: (state, getters) => (instruction = null) => {
				return _.first(getters.steppedTasks(instruction));
			},
			nextTaskAfter: (state, getters) => (taskKey, instruction = null) => {
				let steppedTasks = getters.steppedTasks(instruction);
				let remainingTasks = steppedTasks.slice(_.findIndex(steppedTasks, task => {
					return task.key === taskKey;
				}) + 1);
				return _.first(remainingTasks);
			},
			task: (state, getters) => (taskKey, instruction = null) => {
				return _.find(getters.essentialTasks(instruction), task => {
					return task.key === taskKey;
				});
			},
			blockingTasks: (state, getters) => (taskKey) => {
				let dependsOn = getters.task(taskKey).dependsOn || [];
				let otherTasks = _.filter(getters.remainingTasks(), task => {
					return task.key !== taskKey;
				});
				return _.filter(otherTasks, task => {
					return dependsOn.indexOf(task.key) > -1 && !task.complete;
				});
			},
			instructionsRelatedToTask: (state, getters) => (taskKey) => {
				let ids = getters.task(taskKey).data.instructions || [];
				return _.pickBy(state.authStore.authed.interactiveInstructions, (instruction) => {
					return ids.indexOf(instruction.id) > -1;
				});
			},
			incompleteCases: (state, getters) => {
				return _.filter(state.authStore.authed.interactiveInstructions, (instruction) => {
					return instruction.status !== "complete";
				});
			},
		},
		mutations: {
			setIdCheckSession: (state, data = null) => {
				state.idCheckSession = data;
				state.idCheckSessionTerminated = !data;
			},
		},
	},
));

export default clientPortalStore;
